import slMessages from '../locales/sl_SI.json';

const SlLang = {
  messages: {
    ...slMessages,
  },
  locale: 'sl-SI',
};
export default SlLang;
